import EdModal from "../../../generic/edModal";
import React, { useEffect, useState } from "react";
import DownloadReportPopupDesk, { DownloadEnumReportType, } from "../../../generic/DownloadReports/DownloadReportPopupDesk";
import PopupFail from "../../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import SuccessPopup from "../../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import PopupLoader from "../../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import di from "../di/servicelocator";
import { assetTypeMappingObj, dynamicPNLFilters, TabMapping, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { useDispatch, useSelector } from "react-redux";
import { PNL_HIDE_ERROR, } from "../../../../redux/interfaces/Reports/iPNLReport";
import debounce from "@frameworks/web/utils/debounce";
import CommonSortDrop from "@frameworks/web/components/Reports/CommonComponent/CommonSortDrop";
import CommonFilterAssetDrop from "@frameworks/web/components/Reports/CommonComponent/CommonFilterAssetDrop";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { PNLErrorEnum } from "@adapters/presenters/action-interfaces/Reports/PNLReport";
import { ESortOrder } from "@domains/utils/sort";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import _ from "underscore";
const PnLDownloadSortFilter = (props) => {
    var _a;
    const { loginOrigin } = useParams();
    const [showSearch, setShowSearch] = React.useState(false);
    const [openPopUp, setOpenPopup] = React.useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [downloadSuccess, setDownloadSuccess] = useState(false);
    const [downloadFail, setDownloadFail] = useState(false);
    const [operation, setOperation] = useState();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [OrderBy, setOrderBy] = React.useState(0);
    const [showFilterAssetDropdown, setshowFilterAssetDropdown] = React.useState(false);
    const filters = useSelector((state) => { var _a, _b; return (_b = (_a = state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.FilterData; });
    const showShimmer = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.showShimmer);
    const PNLStreamFromStore = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.stream; }, _.isEqual);
    const [filterData, setFilterData] = React.useState(filters);
    const sortData = useSelector((state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.SortData; });
    const [sortByFilters, setSortByFilters] = useState(sortData);
    const sortKeyDisplayState = {
        Alphabetical: { asc: "Z to A", desc: "A to Z" },
        "P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "P&L absolute": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Realized P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Realized P&L abs": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Unrealized P&L %": { asc: "Lowest to Highest", desc: "Highest to Lowest" },
        "Unrealized P&L abs": {
            asc: "Lowest to Highest",
            desc: "Highest to Lowest",
        },
    };
    const pnlReportError = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.errorData);
    const myAccCode = useSelector((state) => state.accountDetailsReducer.accountCode);
    const emptyValidation = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnlReport.emptyValidation);
    const wrapperRef = React.useRef(null);
    const filterRef = React.useRef(null);
    const handleSearchInput = (e) => {
        props.setSearchVal(e.target.value);
        debounce(() => {
            di.pnlReport.getSearchPNLReportData(e.target.value, props.tabName);
        }, 300)();
    };
    const resetSort = () => {
        di.pnlReport.getSortedPNLReportData({
            displayName: "Alphabetical",
            order: ESortOrder.DESC,
            sortName: "displayName",
        }, false, props.tabName);
        let newSortState = sortByFilters.map((val, i) => {
            i === 0
                ? (val.order = ESortOrder.DESC)
                : (val.order = ESortOrder.UNCHANGED);
            return val;
        });
        setSortByFilters(newSortState);
        //set red dot on sort function
        props.setSortoptionSelected(false);
        props.setshowSortDropdown(false);
    };
    const goBack = () => {
        dispatch({
            type: PNL_HIDE_ERROR,
            errorType: PNLErrorEnum.DOWNLOADSTATUS,
        });
        const tabRecord = TabMapping.find((tabRecord) => {
            var _a, _b;
            if (Array.isArray(props.assetType))
                return (_a = tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) === null || _a === void 0 ? void 0 : _a.find((assetType) => props.assetType.find((y) => y === assetType));
            return (_b = tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) === null || _b === void 0 ? void 0 : _b.find((assetType) => assetType === props.assetType);
        });
        const assetTypeObj = Object.entries(assetTypeMappingObj);
        let appendAssetType;
        assetTypeObj.forEach((assetRecord) => {
            var _a;
            if (((_a = assetRecord[1]) === null || _a === void 0 ? void 0 : _a.assetType) === props.assetType) {
                appendAssetType = assetRecord[0];
            }
        });
        const params = new URLSearchParams({
            reportName: "ProfitandLoss",
            tab: tabRecord.tabEventKey,
            assetType: appendAssetType,
            fromDate: moment(props.fromDate).format("yyyy-MM-DD"),
            toDate: moment(props.toDate).format("yyyy-MM-DD"),
            durationType: props.duration,
        });
        const baseUrl = ".." + getLoginSourceURL(loginOrigin);
        const destination = `${baseUrl}?${params.toString()}`;
        navigate(destination, { replace: true });
    };
    useEffect(() => {
        setSortByFilters(sortData);
    }, [sortData]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target))
                props.setshowSortDropdown(false);
            if (filterRef.current && !filterRef.current.contains(event.target))
                setshowFilterAssetDropdown(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef, filterRef]);
    const resetSearch = () => {
        props.setSearchVal("");
        di.pnlReport.getSearchPNLReportData("", props.tabName);
    };
    const closeSearch = () => {
        if (!props.searchVal)
            setShowSearch(false);
    };
    const sortByFunction = (idx, sortState) => {
        setSortByFilters(sortState);
        const sort = sortState[idx];
        di.pnlReport.getSortedPNLReportData(sort, true, props.tabName);
        //set red dot on sort function
        props.setSortoptionSelected(true);
        props.setshowSortDropdown(false);
    };
    const applyFilter = () => {
        di.pnlReport.getFilteredPNLReportData(filterData, props.tabName);
    };
    const submitEmailDownloadHandler = (email, download) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (props.assetType && download)
            download.assetType = props.assetType;
        if (props.assetType && email)
            email.assetType = props.assetType;
        let expiryMonth = (_b = (_a = filters.expiryMonth) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.filter((filter) => filter.selected).map((x) => moment().month(x.title).format("M"));
        let underlyingAsset = (_d = (_c = filters.underlyingAsset) === null || _c === void 0 ? void 0 : _c.filters) === null || _d === void 0 ? void 0 : _d.filter((filter) => filter.selected).map((x) => x.title);
        if (download) {
            if (props.assetType)
                download.assetType = props.assetType;
            if (props.duration)
                download.duration = props.duration;
            if ((underlyingAsset === null || underlyingAsset === void 0 ? void 0 : underlyingAsset.length) > 0)
                download.underlyingAsset = underlyingAsset.join();
            if ((expiryMonth === null || expiryMonth === void 0 ? void 0 : expiryMonth.length) > 0)
                download.expiryMonth = expiryMonth.join();
            if (props.accCode !== myAccCode)
                download.accodes = props.accCode;
            if (((_f = (_e = props.accCode) === null || _e === void 0 ? void 0 : _e.split(",")) === null || _f === void 0 ? void 0 : _f.length) > 1)
                download.isConsolidated = true;
        }
        if (email) {
            if (props.assetType)
                email.assetType = props.assetType;
            if (props.duration)
                email.duration = props.duration;
            if ((underlyingAsset === null || underlyingAsset === void 0 ? void 0 : underlyingAsset.length) > 0)
                email.underlyingAsset = underlyingAsset.join();
            if ((expiryMonth === null || expiryMonth === void 0 ? void 0 : expiryMonth.length) > 0)
                email.expiryMonth = expiryMonth.join();
            if (props.accCode !== myAccCode)
                email.accodes = props.accCode;
            if (((_h = (_g = props.accCode) === null || _g === void 0 ? void 0 : _g.split(",")) === null || _h === void 0 ? void 0 : _h.length) > 1)
                email.isConsolidated = true;
        }
        di.pnlReport.downloadAndSendReportPNL(props.tabName, email, download);
        setOpenPopup(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pnl-actions d-flex align-items-center justify-content-between" },
            React.createElement("div", { className: "col-2" },
                React.createElement("div", { className: "summarize-pnl" },
                    React.createElement("div", { className: "summarize" },
                        React.createElement("label", { className: "custom-control border-switch" },
                            React.createElement("input", { type: "checkbox", className: "border-switch-control-input", onChange: (e) => {
                                    di.pnlReport.getSummarizePNLReportData(e.currentTarget.checked, props.tabName);
                                    props.setIsSummarize(e.currentTarget.checked);
                                }, defaultChecked: props.isSummarize, disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                                    (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                        EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                                    showShimmer }),
                            React.createElement("span", { className: "border-switch-control-indicator" }),
                            React.createElement("span", { className: "teleport-switch-control-description" }, "Summarize Values"))))),
            React.createElement("div", { className: "col-2" },
                React.createElement("div", { className: "summarize-pnl" },
                    React.createElement("div", { className: "summarize" },
                        React.createElement("label", { className: "custom-control border-switch" },
                            React.createElement("input", { type: "checkbox", className: "border-switch-control-input", onClick: () => {
                                    di.pnlReport.pnlToggleStream(!PNLStreamFromStore);
                                }, defaultChecked: PNLStreamFromStore, disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                                    (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                        EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                                    showShimmer }),
                            React.createElement("span", { className: "border-switch-control-indicator" }),
                            React.createElement("span", { className: "teleport-switch-control-description" }, "Stream"))))),
            React.createElement("div", { className: "col-8 d-flex justify-content-end" },
                React.createElement("div", { className: "downloads" },
                    React.createElement("button", { className: "btn btn-outline-primary downloads ", onClick: () => setOpenPopup(true), disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                            showShimmer },
                        React.createElement("i", { className: "edel-icon-download " }),
                        "Download")),
                React.createElement("div", { className: `searchbar-c ` },
                    React.createElement("div", { className: "input-group" },
                        React.createElement("div", { className: "input-group-prepend" },
                            React.createElement("label", { htmlFor: "focus-input" },
                                React.createElement("i", { className: `edel-icon-search input-group-text ${showSearch ? " ser-icon bg-white " : ""}`, onClick: () => {
                                        if (!((pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                                            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL]
                                                    .icon ||
                                            showShimmer))
                                            setShowSearch(true);
                                    } }))),
                        React.createElement("input", { id: "focus-input", type: "search", className: `form-control ${showSearch ? "input-ex bg-white " : ""}`, placeholder: "Search", "aria-label": "search", "aria-describedby": "basic-addon1", name: "search", onChange: handleSearchInput, onFocus: () => setShowSearch(true), value: props.searchVal, onBlur: closeSearch, autoComplete: "off", disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                                (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                    EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                                showShimmer }),
                        showSearch && (React.createElement("div", { className: "input-group-prepend" },
                            React.createElement("label", { htmlFor: "focus-input" },
                                React.createElement("i", { className: `edel-icon-close input-group-text ${showSearch ? "ex-close bg-white " : ""}`, onClick: resetSearch })))))),
                React.createElement("div", { className: "sort", ref: wrapperRef },
                    React.createElement("button", { className: props.showSortDropdown
                            ? "btn showblue btn-outline-primary sorting"
                            : "btn btn-outline-primary sorting", disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                            showShimmer, onClick: () => {
                            props.setshowSortDropdown(!props.showSortDropdown);
                            window.scrollTo(0, 130);
                        } },
                        React.createElement("i", { className: "edel-icon-sort sort-filter-icon" }, props.sortOptionSelected && ((_a = sortByFilters[0]) === null || _a === void 0 ? void 0 : _a.order) != -1 && (React.createElement("span", { className: "sort-filter-selected" })))),
                    props.showSortDropdown && (React.createElement("div", { className: "showSortDropdown" },
                        React.createElement(CommonSortDrop, { sortKeyDisplayState: sortKeyDisplayState, OrderBy: OrderBy, setOrderBy: setOrderBy, sortByFilters: sortByFilters, sortByFunction: sortByFunction, setSortByFilters: setSortByFilters, resetSort: resetSort, parentClass: "filterasset-drop-common-asset", themeClass: "sort-drop-light-blue-theme" })))),
                React.createElement("div", { className: "filter pnl-filter-desk", ref: filterRef },
                    React.createElement("button", { className: showFilterAssetDropdown
                            ? "btn showblue btn-outline-primary filter"
                            : "btn btn-outline-primary filter", disabled: (pnlReportError === null || pnlReportError === void 0 ? void 0 : pnlReportError.isOpen) ||
                            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) ===
                                EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.PNL].icon ||
                            showShimmer, onClick: () => {
                            setshowFilterAssetDropdown(!showFilterAssetDropdown);
                            window.scrollTo(0, 130);
                        } },
                        React.createElement("i", { className: "edel-icon-filter filter-icon" }, props.showFDot > 0 && (React.createElement("span", { className: "filter-selected" })))),
                    showFilterAssetDropdown && filterData && (React.createElement(CommonFilterAssetDrop, { setshowFilterAssetDropdown: setshowFilterAssetDropdown, setShowFDot: props.setShowFDot, filterData: filterData, setFilterData: setFilterData, applyFilter: applyFilter, showAsset: false, dynamicFiltersName: dynamicPNLFilters, replacedFilterName: {
                            simpleFilter: "Filter By",
                        }, clearSessionFilters: di.pnlReport.removeSessionFilters, themeClass: "filterasset-drop-light-blue-theme", parentClass: "filterasset-drop-common-asset" }))),
                React.createElement("div", null,
                    React.createElement(EdModal, { show: openPopUp, setShow: setOpenPopup, size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalDPTitle", title: "Download Profit & Loss Report", showFooter: false },
                        React.createElement("div", { className: "downloadHoldingDesk-light-blue-theme" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-12 col-lg-12 downloadHoldingDesk-form-light-blue" },
                                    React.createElement(DownloadReportPopupDesk, { startDate: props.fromDate, endDate: props.toDate, withEndDate: true, showLoader: showLoader, setShowLoader: setShowLoader, setDownloadSuccess: setDownloadSuccess, setDownloadFail: setDownloadFail, resetFields: openPopUp, setOperation: setOperation, assetType: props === null || props === void 0 ? void 0 : props.assetType, 
                                        // duration={props.duration}
                                        submit: submitEmailDownloadHandler, reportType: DownloadEnumReportType.PNL, avoidEMail: props.avoidEmail, themeClass: { radio: "lightblue-radio", submitBtn: "" } }))))),
                    showLoader && (React.createElement("div", { className: "modalBackground" },
                        React.createElement("div", { className: "modalContainer pnl-report-loader" },
                            React.createElement(PopupLoader, { Title: "Profit & Loss", isDownload: true, messageReactNode: React.createElement(React.Fragment, null,
                                    React.createElement("label", { className: "update-message" }, "Your request is being processed")) })))),
                    downloadSuccess && (React.createElement("div", { className: "modalBackground" },
                        React.createElement("div", { className: "modalContainer pnl-report-success" },
                            React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, Title: "Profit & Loss", operation: operation, pageName: "Profit & Loss", sendBack: true, goBack: goBack, isDownload: true, messageReactNode: React.createElement(React.Fragment, null,
                                    React.createElement("label", { className: "update-message" }, "Your request was successfully processed.")) })))),
                    downloadFail && (React.createElement("div", { className: "modalBackground" },
                        React.createElement("div", { className: "modalContainer" },
                            React.createElement(PopupFail, { setDownloadFail: setDownloadFail, Title: "Profit & Loss", operation: operation, pageName: "Profit & Loss", isDownload: true, sendBack: true, goBack: goBack })))))))));
};
export default PnLDownloadSortFilter;
